module.exports = __webpack_public_path__ + "img/ic_emoji_happy.fa7142d3.png";